import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import CookieBanner from "@/components/CookieBanner";
import FloatingCTA from "@/components/FloatingCTA";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import WebDesignPage from "@/pages/WebDesignPage";
// import Microsoft365Page from "@/pages/Microsoft365Page"; // Hidden - can re-enable
import AIAutomationPage from "@/pages/AIAutomationPage";
// import ITConsultingPage from "@/pages/ITConsultingPage"; // Hidden - can re-enable
import WebDesignEastAnglia from "@/pages/WebDesignEastAnglia";
// import ITConsultingEastAnglia from "@/pages/ITConsultingEastAnglia"; // Hidden - can re-enable

// Handle hash scrolling after navigation
function HashScroller() {
  const location = useLocation();
  
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.hash, location.pathname]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="min-h-screen bg-[#030712]">
      <BrowserRouter>
        <ScrollToTop />
        <HashScroller />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/website-design-uk" element={<WebDesignPage />} />
            <Route path="/ai-automation-agents-uk" element={<AIAutomationPage />} />
            <Route path="/website-design-east-anglia" element={<WebDesignEastAnglia />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
        <FloatingCTA />
        <CookieBanner />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
